<div class="ui-kit-bottom-buttons-block">
  <button class="back-button" data-qa-button="go-back" (click)="back()">
    {{ 'group.back' | translate }}
  </button>
  <button
    class="button_blue"
    data-qa-button="save-kkm"
    [disabled]="isDisable"
    (click)="saveKkmData()"
  >
    {{ 'organization.save' | translate }}
  </button>
</div>
